<template>
    <div>
        <!-- prop `add-on-change` is needed to enable adding tags vie the `change` event -->
        <b-form-tags v-model="value" add-on-change no-outer-focus class="mb-2" @input="$emit('input', $event)">
            <template v-slot=" { tags, inputAttrs, inputHandlers, disabled, removeTag }
        ">
        <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
                <b-form-tag
                        @remove="removeTag(tag)"
                        :title="tag"
                        :disabled="disabled"
                        variant="info"
                >{{ tag }}
                </b-form-tag>
            </li>
        </ul>
        <b-form-select
                v-bind="inputAttrs"
                v-on="inputHandlers"
                :disabled="disabled || availableOptions.length === 0"
                :options="availableOptions"
        >
            <template v-slot:first>
                <!-- This is required to prevent bugs with Safari -->
                <option disabled value="">{{label}}</option>
            </template>
        </b-form-select>
</template>
</b-form-tags>
</div>
</template>

<script>
    export default {
        name: "TagInput",
        props: ["options", "label", "initValue"],
        data() {
            return {
                value: this.initValue
            }
        },
        watch: {
            initValue: function(val,) {
                this.value = val
            }
        },
        computed: {
            availableOptions() {
                return this.options.filter(opt => this.value.indexOf(opt) === -1)
            }
        }
    }
</script>

<style scoped>

</style>
